import React, { forwardRef } from "react";
import { Sizing, Variants } from "../../shared/utils/interfaces";
import Icon from "../Icon/Icon";

const sizeMap: Record<Sizing, string> = {
  big: "4rem",
  default: "2.7rem",
  small: "2.4rem",
  mini: "2rem",
};

const checkSizeMap: Record<Sizing, string> = {
  big: "2rem",
  default: "1.5rem",
  small: "1.3rem",
  mini: "1rem",
};

export interface CheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  children?: React.ReactNode;
  variant?: Variants;
  isDisabled?: boolean;
  sizing?: Sizing;
  active?: boolean;
  bg?: any;
}

const Checkbox = forwardRef<any, CheckboxProps>(
  (
    {
      children,
      isDisabled = false,
      sizing = "default",
      name = "checkbox",
      active = false,
      bg,
      ...props
    },
    ref
  ) => {
    return (
      <div className="flex items-center">
        <div
          className="relative flex-[0_0_auto] rounded-lg border-[0.1rem] shadow-[0_2px_8px_#999]"
          style={{
            width: sizeMap[sizing],
            height: sizeMap[sizing],
            borderColor: active ? "transparent" : "var(--grey-blue)",
            background: isDisabled
              ? "var(--grey-blue)"
              : active
                ? bg || "var(--primary)"
                : "transparent",
          }}
        >
          <input
            aria-label={name}
            name={name}
            ref={ref}
            type={"checkbox"}
            disabled={isDisabled}
            className="absolute left-1/2 top-1/2 z-5 -translate-x-1/2 -translate-y-1/2 opacity-0"
            style={{
              width: sizeMap[sizing],
              height: sizeMap[sizing],
              cursor: isDisabled ? "not-allowed" : "pointer",
            }}
            {...props}
          />
          <Icon
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 fill-white transition-all"
            style={{
              opacity: active ? 1 : 0,
              width: checkSizeMap[sizing],
              height: checkSizeMap[sizing],
            }}
            variants="check"
          />
        </div>
        {children && (
          <label htmlFor={name} className="ml-6 text-[small]" style={{ fontWeight: 300 }}>
            {children}
          </label>
        )}
      </div>
    );
  }
);

export default Checkbox;
